// Copyright (c) Ping. All rights reserved.
//
// Static-maps config reader — WEB variant. Reads the Vite build env
// (`import.meta.env.VITE_MAPS_*`). `import.meta` is valid here because
// Vite serves real ES modules; the native sibling (`locationMapsEnv.ts`)
// avoids the token entirely so Hermes never chokes. Prefers the generic
// VITE_MAPS_KEY + VITE_MAPS_STATIC_URL template; falls back to the older
// provider-specific tokens. Returns null when nothing is wired.

export type MapsConfig =
  | { kind: 'template'; template: string; key: string }
  | { kind: 'mapbox' | 'google' | 'maptiler'; token: string };

export function readMapsEnv(): MapsConfig | null {
  const env =
    typeof import.meta !== 'undefined'
      ? ((import.meta as unknown as { env?: Record<string, string | undefined> }).env ?? null)
      : null;
  if (!env) return null;
  if (env.VITE_MAPS_KEY && env.VITE_MAPS_STATIC_URL) {
    return { kind: 'template', template: env.VITE_MAPS_STATIC_URL, key: env.VITE_MAPS_KEY };
  }
  if (env.VITE_MAPBOX_TOKEN) return { kind: 'mapbox', token: env.VITE_MAPBOX_TOKEN };
  if (env.VITE_GOOGLE_MAPS_KEY) return { kind: 'google', token: env.VITE_GOOGLE_MAPS_KEY };
  if (env.VITE_MAPTILER_KEY) return { kind: 'maptiler', token: env.VITE_MAPTILER_KEY };
  return null;
}
